/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Newsletter_BodyInputs */

const en_why_listening_newsletter_body = /** @type {(inputs: Why_Listening_Newsletter_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newsletters land in your Listening inbox. Save articles with the Chrome extension.`)
};

const es_why_listening_newsletter_body = /** @type {(inputs: Why_Listening_Newsletter_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las newsletters llegan a tu bandeja de Listening. Guarda artículos con la extensión de Chrome.`)
};

/**
* | output |
* | --- |
* | "Newsletters land in your Listening inbox. Save articles with the Chrome extension." |
*
* @param {Why_Listening_Newsletter_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_newsletter_body = /** @type {((inputs?: Why_Listening_Newsletter_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Newsletter_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_newsletter_body(inputs)
	return en_why_listening_newsletter_body(inputs)
});